import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Grid,
  Typography
} from '@material-ui/core';
import Textfield from './FormsUI/Textfield';
import Select from './FormsUI/Select';
import Checkbox from './FormsUI/Checkbox';
import Button from './FormsUI/Button';
import creditos from '../data/creditos.json';
import axios from 'axios'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(8),
  },
}));

const INITIAL_FORM_STATE = {
  nombre: '',
  correo: '',
  telefono: '',
  tipoDeCredito: '',
  comentario: '',
  aceptado: false
}

const FORM_VALIDATION = Yup.object().shape({  
  nombre: Yup.string()
    .required('El nombre completo es requerido'),
  correo: Yup.string()
    .email('Por favor ingresa un correo electrónico válido')
    .required('El correo electrónico es requerido.'),
  telefono: Yup.number()
    .integer()
    .typeError('Por favor ingresa un teléfono válido')
    .required('El teléfono es requerido.'),
  tipoDeCredito: Yup.string()
    .required('El tipo de crédito es requerido'),
  comentario: Yup.string(),
  aceptado: Yup.boolean()
    .oneOf([true], 'Se deben de aceptar los términos y condiciones.')
    .required('Se deben de aceptar los términos y condiciones.')
  });

export const Signup = () => {
  const classes = useStyles();

const [sentForm, setSentForm] = useState(false);
const [isSendingForm, setIsSendingForm] = useState(false);

if (!sentForm) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Container maxWidth="md">
          <div className={classes.formWrapper}>
            <Formik
              initialValues={{
                ...INITIAL_FORM_STATE
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values, {resetForm}) => {
                setIsSendingForm(true)
                setSentForm(true)
                console.log(values);
                var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
                
                //Azure
                //Uncomment this on deployment
                axios.post('https://creditocrediclub.azurewebsites.net/flask/api', {
                  
                //Local
                //Comment this on deployment
                //axios.post('http://localhost:5000/flask/api', {
                  "nombre": values.nombre,
                  "correo": values.correo,
                  "telefono": values.telefono,
                  "tipoDeCredito": values.tipoDeCredito,
                  "aceptado": values.aceptado,
                  "timestamp": localISOTime,
                  "comentario": values.comentario
                }).then(response => {
                  console.log(response)
                  resetForm();
                  setIsSendingForm(false)
                  alert(response.data.message)
                }).catch(error => {
                  console.log(error)
                  alert(error.data.message)
                  setSentForm(false)
                })
                
                
              }}
            >
              <Form>

                <Grid container spacing={2}>

                  <Grid item xs={12}>
                    <Typography>
                    Formulario de solicitud de crédito
                    </Typography>
                    
                  </Grid>

                  <Grid item xs={12}>
                    <Textfield
                      name="nombre"
                      label="Nombre Completo"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Textfield
                      name="correo"
                      label="Correo electrónico"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Textfield
                      name="telefono"
                      label="Teléfono"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Select
                      name="tipoDeCredito"
                      label="Crédito Crediclub.com de interés"
                      options={creditos}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Textfield
                      name="comentario"
                      label="Comentario (opcional)"
                      multiline={true}
                      rows={2}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Checkbox
                      name="aceptado"
                      legend="Política de privacidad"
                      label={<div>Estoy de acuerdo con el <a href="https://crediclub.com/politica-de-privacidad/" target="_blank">aviso de privacidad</a></div>}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button>
                      Enviar
                    </Button>
                  </Grid>


                </Grid>

              </Form>
            </Formik>

          </div>
        </Container>
      </Grid>

    </Grid>
  );
} else {
  if (isSendingForm){
    return(
      <Grid container>
        <Box m={0} pt={5}>
          <h2>La solicitud está siendo enviada</h2>
        </Box>
        
        <Grid item xs={12}>
          <Container maxWidth="md">
            <div className={classes.formWrapper}>
              <Box m={20} pt={0}> 
                <CircularProgress size={150}/>
              </Box>
            </div>
          </Container>
        </Grid>
    </Grid>
    );
  } else {
    return(
      <Grid container>
        <Box m={0} pt={5}>
          <h2>¡Gracias por tu solicitud!</h2>
        </Box>
  
        <Grid item xs={12}>
          <Container maxWidth="md">
            <div className={classes.formWrapper}>
  
            </div>
          </Container>
        </Grid>
    </Grid>
    );
  }
  
}
  
}